import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faTimesCircle, faCheckCircle, faInfoCircle, faExclamationCircle} from '@fortawesome/fontawesome-free-solid';


export class Msg extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            close: false
        }

        this.close = this.close.bind(this);
    }

    close () {
        this.setState({close: true});
    }

    render () {
        const {data, type, allowHTML, position, time} = this.props;

        const classes = `msg msg-${type} msgAnimation msgPosition-${position} ${this.state.close ? 'msgForceClose' : ""}`;
        const animationTime = {animationDuration: time};

        return (
            <div className={classes} style={animationTime}>
                <div className="msgIcon">
                    {type === 'success' && <FontAwesomeIcon icon={faCheckCircle}/>}
                    {type === 'info' && <FontAwesomeIcon icon={faInfoCircle}/>}
                    {type === 'error' && <FontAwesomeIcon icon={faExclamationCircle}/>}
                </div>
                <div className="msgContent">
                    {!allowHTML && <div className="msgText">{data}</div>}
                    {allowHTML && <div className="msgText" dangerouslySetInnerHTML={{__html:data}}></div>}
                    <div className="msgClose">
                        <FontAwesomeIcon icon={faTimesCircle} onClick={this.close}/>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Messages/Msg.jsx